import React from 'react'

type SettingsLayoutWrapperProps = {
  width?: number | string | undefined
  className?: string
  children: React.ReactNode
}

export function SettingsLayoutWrapper({
  width = 700,
  className = '',
  children = null,
}: SettingsLayoutWrapperProps) {
  return (
    <div className="padding-vertical-large width-full scrollable flexbox flexbox-column flexbox-align-center flexbox-grow">
      <div className={className} style={{ width }}>
        {children}
      </div>
    </div>
  )
}
